var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Site } from '@debbie/common/dist';
import { validateNewUserOnCustomer, } from '@debbie/common/dist/customers';
import { isCaseworker } from '@debbie/common/dist/permissions';
import { c, h } from '@debbie/cortex/dist';
import * as customersAPI from '@debbie/cortex/dist/api/customers';
import { selectCustomerById } from '@debbie/cortex/dist/customers/selectors';
import { selectRole } from '@debbie/cortex/dist/me/selectors';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
import Alert from '../Alert';
import Button from '../Button';
import ButtonIcon from '../ButtonIcon';
import CopyToClipboard from '../CopyToClipboard';
import { Edit, Globe, Link2, Repeat, User } from '../Icons';
import Input from '../Input';
import Modal from '../Modal';
import PlaceholderLoader from '../PlaceholderLoader';
import CreateUserOnCustomer, { getNewUser } from './CreateUserOnCustomer';
import UserOnCustomer from './UserOnCustomer';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors';
import { APCOA_EI_TENANT_IDS } from '@debbie/common/dist/bespoke/apcoa';
import APCOAAddDMRUser from '../bespoke/APCOA/APCOAAddDMRUser';
import { Lang } from '@debbie/common/dist/lang';
import { useCreditor } from '@debbie/cortex/dist/creditors';
const CustomerPreview = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const customer = useSelector((s) => selectCustomerById(s, props.customerId));
    const creditorLoadable = useCreditor(customer === null || customer === void 0 ? void 0 : customer.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const meRole = useSelector(selectRole);
    const site = useSelector((s) => s.site);
    const tenantId = useSelector(selectTenantId);
    const [addCustomerModalOpen, setAddCustomerModalOpen] = useState(false);
    const [editReferenceIdModalOpen, setEditReferenceIdModalOpen] = useState(false);
    const [referenceId, setReferenceId] = useState('');
    const [isCompany, setIsCompany] = useState(null);
    const [savingIsCompany, setSavingIsCompany] = useState(false);
    const [savingReferenceId, setSavingReferenceId] = useState(false);
    const [addingNewUser, setAddingNewUser] = useState(false);
    const [newUser, setNewUser] = useState(null);
    useEffect(() => {
        if (!customer) {
            c.customers.getById(props.customerId, true);
        }
    }, [props.customerId]);
    useEffect(() => {
        if (customer) {
            setReferenceId(customer.referenceId || '');
            setIsCompany(customer.isCompany);
        }
    }, [customer]);
    if (!customer)
        return (React.createElement("div", null,
            React.createElement(PlaceholderLoader, null)));
    const isMeCaseWorker = meRole && isCaseworker(meRole);
    const canAddUsers = site === Site.Caseworker && isMeCaseWorker;
    const erpLink = creditor && creditor.erpLink && customer.referenceId
        ? creditor.erpLink
        : null;
    const saveReferenceId = (_referenceId) => __awaiter(void 0, void 0, void 0, function* () {
        setSavingReferenceId(true);
        try {
            yield customersAPI.patch(customer.customerId, {
                referenceId: _referenceId || null,
            });
            yield c.customers.getById(customer.customerId);
            setEditReferenceIdModalOpen(false);
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
        setSavingReferenceId(false);
    });
    const saveIsCompany = (_isCompany) => __awaiter(void 0, void 0, void 0, function* () {
        setSavingIsCompany(true);
        try {
            yield customersAPI.patch(customer.customerId, {
                isCompany: _isCompany,
            });
            yield c.customers.getById(customer.customerId);
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
        setSavingIsCompany(false);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(CustomerStyled, null,
            React.createElement(HeaderStyled, null,
                React.createElement(ReferenceIdStyled, null,
                    customer.referenceId ? (React.createElement(CopyToClipboard, { text: customer.referenceId, iconStyle: {
                            margin: '0.2em 0.3em -0.2em -0.1em',
                            width: '16px',
                            height: '16px',
                        } }, customer.referenceId)) : (customer.referenceId),
                    site === Site.Caseworker && (React.createElement(Edit, { style: {
                            margin: '0em 0.3em 0em 0.1em',
                            width: '16px',
                            height: '16px',
                            cursor: 'pointer',
                        }, onClick: () => setEditReferenceIdModalOpen(!editReferenceIdModalOpen) })),
                    erpLink && (React.createElement(Link2, { style: {
                            margin: '0.2em 0.3em -0.2em 0.1em',
                            width: '16px',
                            height: '16px',
                            cursor: 'pointer',
                        }, onClick: () => {
                            if (erpLink && customer.referenceId) {
                                const url = erpLink.replace('{{customerReferenceId}}', customer.referenceId);
                                window.open(url, '_blank');
                            }
                        } }))),
                React.createElement(IsCompanyStyled, { onClick: () => {
                        if (!savingIsCompany && site === Site.Caseworker)
                            saveIsCompany(!isCompany);
                    }, disabled: site !== Site.Caseworker }, savingIsCompany ? (React.createElement(PlaceholderLoader, { width: "90px", height: "17px" })) : (React.createElement(React.Fragment, null,
                    customer.isCompany ? (React.createElement("span", null,
                        React.createElement(Globe, { style: {
                                margin: '0.1em 0 -0.1em',
                            } }),
                        ' ',
                        lang.debtors.company)) : (React.createElement("span", null,
                        React.createElement(User, { style: {
                                margin: '0.1em 0 -0.1em',
                            } }),
                        ' ',
                        lang.debtors.private)),
                    site === Site.Caseworker && typeof isCompany === 'boolean' && (React.createElement(Repeat, { style: {
                            margin: '0.2em 0.3em -0.2em 0.4em',
                            width: '16px',
                            height: '16px',
                        } })))))),
            !customer.users.find((u) => u.contact) && (React.createElement(Alert, { style: { marginTop: '10px' }, message: lang.customers.noContactSelected, size: "small" })),
            React.createElement("div", { style: { marginBottom: '10px' } }, customer.users
                .sort((a, b) => a.id - b.id)
                .map((user) => (React.createElement(UserOnCustomer, { key: user.id, user: user, customer: customer, selected: !!(props.selectedUserId && user.userId === props.selectedUserId), onClick: props.onClickOnUser, noPreview: props.noPreview })))),
            tenant && canAddUsers && (React.createElement(ButtonIcon, { value: lang.customers.addParty, onClick: () => {
                    setNewUser(getNewUser(tenant, true));
                    setAddCustomerModalOpen(!addCustomerModalOpen);
                } }))),
        addCustomerModalOpen && (React.createElement(Modal, { header: lang.customers.addParty, onToggle: () => setAddCustomerModalOpen(!addCustomerModalOpen) },
            tenantId &&
                APCOA_EI_TENANT_IDS.includes(tenantId) &&
                props.caseId && (React.createElement(APCOAAddDMRUser, { onSelect: (data) => __awaiter(void 0, void 0, void 0, function* () {
                    setAddingNewUser(true);
                    try {
                        if (newUser) {
                            if (data.isCompany !== customer.isCompany) {
                                yield customersAPI.patch(customer.customerId, {
                                    isCompany: data.isCompany,
                                });
                            }
                            yield customersAPI.addUser(customer.customerId, {
                                contact: true,
                                details: {
                                    name: data.name,
                                    birthdate: data.birthdate,
                                    address: data.address,
                                    description: data.description,
                                    cvr: data.cvr,
                                },
                                lang: Lang.da,
                                relation: 'debtor',
                            });
                            yield c.customers.getById(customer.customerId);
                            setAddCustomerModalOpen(false);
                        }
                    }
                    catch (error) {
                        alert('Error');
                    }
                    setAddingNewUser(false);
                }), caseId: props.caseId })),
            newUser && (React.createElement(CreateUserOnCustomer, { user: newUser, isCompany: customer.isCompany, onDetailsChange: (c) => setNewUser(Object.assign(Object.assign({}, newUser), { details: Object.assign(Object.assign({}, newUser === null || newUser === void 0 ? void 0 : newUser.details), c) })), onChange: (c) => setNewUser(Object.assign(Object.assign({}, (newUser || {})), c)) })),
            React.createElement(Button, { block: true, disabled: !(newUser && validateNewUserOnCustomer(customer, newUser)), onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    setAddingNewUser(true);
                    try {
                        if (newUser) {
                            yield customersAPI.addUser(customer.customerId, newUser);
                            yield c.customers.getById(customer.customerId);
                            setAddCustomerModalOpen(false);
                        }
                    }
                    catch (error) {
                        alert('Error');
                    }
                    setAddingNewUser(false);
                }), loading: addingNewUser }, lang.customers.addParty))),
        editReferenceIdModalOpen && (React.createElement(Modal, { header: lang.customers.referenceId, onToggle: () => setEditReferenceIdModalOpen(!editReferenceIdModalOpen), maxWidth: "300px" },
            React.createElement(Input, { autofocus: true, placeholder: lang.customers.referenceId, value: referenceId, onChange: (e) => {
                    setReferenceId(e.target.value);
                }, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        saveReferenceId(referenceId);
                    }
                } }),
            React.createElement(Button, { loading: savingReferenceId, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    saveReferenceId(referenceId);
                }), block: true }, lang.misc.save)))));
};
export default CustomerPreview;
const HeaderStyled = styled.div `
  margin: -19px 0 34px -3px !important;
  position: relative;
`;
const ReferenceIdStyled = styled.div `
  background: white;
  top: 0px;
  font-size: 14px !important;
  position: absolute;
  padding: 0 3px;

  & > div > span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 200px;
    display: inline-block;
  }
`;
const IsCompanyStyled = styled.div `
  background: white;
  top: 1px;
  right: 0px;
  font-size: 14px !important;
  position: absolute;
  padding: 0 3px;
  ${(props) => (props.disabled ? '' : 'cursor: pointer;')}
`;
const CustomerStyled = styled.div `
  border: 1px solid #efefef;
  border-radius: 3px;
  padding: 8px;
  margin: 10px 0 10px 0;
  position: relative;
`;
//# sourceMappingURL=CustomerPreview.js.map